import { render, staticRenderFns } from "./global-header.vue?vue&type=template&id=3238c416"
import script from "./global-header.vue?vue&type=script&lang=js"
export * from "./global-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports